import React, { memo } from 'react'

import logo from '../../assets/images/logo.png'
import logoWhite from '../../assets/images/logo_white.png'

const Logo = ({ className = '', isWhite = false }) => {
  return (
    <div className={`logo_container ${className}`}>
      {isWhite ? (
        <img className="logo" src={logoWhite} alt="company logo" />
      ) : (
        <img className="logo" src={logo} alt="company logo" />
      )}
    </div>
  )
}

export default memo(Logo)
